import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setPageTitle } from '../../features/PageTitleSlice.ts'

export function useSetTitle(title: string | null | undefined) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!title) return
    //Sets Title in the store to use by App Layout
    dispatch(setPageTitle(title))
  })
}
